<template>
    <div class="payment-confirmed">
        <header class="absolute">
            <a :href="ctaRedirectTo.path" :title="ctaRedirectTo.title">
                <SaasIcon
                    icon="svgLogoSellsyText"
                    :width="118"
                    :height="28"
                    class="ml-2 mt-2 secondary-blue"
                />
            </a>
        </header>
        <section class="flex-column hp-10 jc-center ai-center">
            <SaasIcon icon="svgCheck" :width="171" :height="162" />
            <h1 class="payment-confirmed-title">
                {{ $l10n.__('Merci de vous être abonné à Sellsy !') }}
            </h1>
            <p class="payment-confirmed-subtitle">
                {{ $l10n.__('Un email de confirmation vient de vous être envoyé.') }}
            </p>
            <a
                class="payment-confirmed-cta"
                :href="ctaRedirectTo.path"
                :title="ctaRedirectTo.title"
            >
                <CompassButton
                    :label="ctaRedirectTo.btnLabel"
                    type="primary"
                    size="large"
                    class="wp-10 px-4 fs-4 lh-24"
                />
            </a>
            <p
                class="payment-confirmed-help"
                v-html="
                    $t.__('pages.subscription.need_help', {
                        startLinkHelp: `<a class='fs-4 link' href='https://help.sellsy.com' target='_blank'>`,
                        startLinkContact: `${
                            isConnected
                                ? `<a class='fs-4 link' onclick='MySupport.getForm()'>`
                                : `<a class='fs-4 link' href='https://go.sellsy.com'>`
                        }`,
                        endLink: `</a>`,
                    })
                "
            ></p>
        </section>
    </div>
</template>

<script>
import SaasIcon from 'vcomponents/common/SaasIcon.vue';

export default {
    name: 'PaymentConfirmed',
    components: {
        SaasIcon,
    },
    props: {
        isConnected: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    computed: {
        /**
         * Return an object with path and title of call to action
         */
        ctaRedirectTo() {
            return {
                path: '/home',
                title: this.$l10n.__("Page d'accueil"),
                btnLabel: this.$l10n.__('Utiliser Sellsy maintenant'),
            };
            // return this.isConnected
            //     ? {path: "/home", title: this.$l10n.__('Page d\'accueil'), btnLabel: this.$l10n.__("Utiliser Sellsy maintenant")}
            //     : {path: "http://go.sellsy.com/", title: this.$l10n.__('Sellsy'), btnLabel: this.$l10n.__("Retourner sur Sellsy")}
            // ;
        },
    },
};
</script>

<style lang="scss">
@use '~@sellsy/styleguide/src/_variables' as *;

.page-sam-v4-selfservice-cart-checkout-paid #sellsy_app,
.page-sam-subscription-payment-confirmed #sellsy_app {
    background-color: $secondary-grey !important;

    .payment-confirmed {
        .payment-confirmed-title {
            font-size: 32px;
            line-height: 39px;
            font-weight: $font-weight-regular;
            margin-top: 56px;
            margin-bottom: var(--spacing-3);
            text-align: center;
        }
        .payment-confirmed-subtitle {
            font-size: $very-big-font-size;
            line-height: 26px;
            font-weight: $font-weight-regular;
            margin: 0;
            color: $gray-60;
            text-align: center;
        }
        .payment-confirmed-cta {
            margin-top: var(--spacing-6);
            margin-bottom: var(--spacing-4);
            > * {
                line-height: 22px;
            }
        }
        .payment-confirmed-help {
            font-size: $big-font-size;
            line-height: 24px;
            font-weight: $font-weight-semibold;
            margin: 0;
            text-align: center;
        }
    }
}
</style>
